import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export default function TermsOfService() {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      {/* Header */}
      <div className="bg-white border-b border-stone-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/" className="p-2 hover:bg-stone-100 rounded-lg transition-colors">
            <ArrowLeft className="w-5 h-5 text-stone-600" />
          </Link>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#6B7B3F] rounded-xl flex items-center justify-center">
              <FileText className="w-5 h-5 text-white" />
            </div>
            <h1 className="text-xl font-heading font-bold text-[#292524]">
              {lang === 'hr' ? 'Uvjeti Korištenja' : 'Terms of Service'}
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl border border-stone-200 p-6 md:p-10 space-y-8">
          
          <div className="text-sm text-stone-500 mb-6">
            {lang === 'hr' ? 'Datum stupanja na snagu: 3. ožujka 2026.' : 'Effective Date: March 3, 2026'}
          </div>

          {lang === 'hr' ? (
            <>
              {/* Croatian Version */}
              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">1. Prihvaćanje uvjeta</h2>
                <p className="text-stone-600 leading-relaxed">
                  Korištenjem web aplikacije Bereket ("Usluga"), pristajete na ove Uvjete korištenja. 
                  Ako se ne slažete s bilo kojim dijelom uvjeta, ne smijete koristiti našu Uslugu.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">2. Opis usluge</h2>
                <p className="text-stone-600 leading-relaxed">
                  Bereket je web aplikacija za praćenje duhovnih aktivnosti koja korisnicima omogućuje:
                </p>
                <ul className="list-disc list-inside text-stone-600 space-y-2 ml-4">
                  <li>Praćenje dnevnih namaza</li>
                  <li>Bilježenje dobrih djela i bereket aktivnosti</li>
                  <li>Vođenje duhovnog dnevnika</li>
                  <li>Korištenje zikr brojača</li>
                  <li>Čitanje Kur'ana</li>
                  <li>Praćenje sadake</li>
                  <li>Planiranje duhovnih aktivnosti</li>
                  <li>Prikaz vremena namaza i smjera kible</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">3. Korisnički račun</h2>
                <div className="space-y-3">
                  <h3 className="text-lg font-medium text-[#292524]">3.1 Registracija</h3>
                  <p className="text-stone-600 leading-relaxed">
                    Za korištenje određenih funkcija potrebna je registracija. Možete se registrirati putem email adrese 
                    i lozinke ili putem Google prijave.
                  </p>
                </div>
                <div className="space-y-3">
                  <h3 className="text-lg font-medium text-[#292524]">3.2 Odgovornost za račun</h3>
                  <p className="text-stone-600 leading-relaxed">
                    Odgovorni ste za čuvanje povjerljivosti svojih podataka za prijavu i za sve aktivnosti koje se odvijaju 
                    putem vašeg računa.
                  </p>
                </div>
                <div className="space-y-3">
                  <h3 className="text-lg font-medium text-[#292524]">3.3 Točnost informacija</h3>
                  <p className="text-stone-600 leading-relaxed">
                    Slažete se da ćete pružiti točne i potpune informacije prilikom registracije i da ćete ih ažurirati 
                    kada je to potrebno.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">4. Prihvatljivo korištenje</h2>
                <p className="text-stone-600 leading-relaxed">Slažete se da nećete:</p>
                <ul className="list-disc list-inside text-stone-600 space-y-2 ml-4">
                  <li>Koristiti Uslugu za bilo kakve nezakonite svrhe</li>
                  <li>Pokušati neovlašteno pristupiti našim sustavima</li>
                  <li>Ometati ili prekidati rad Usluge</li>
                  <li>Prenositi viruse ili maliciozni kod</li>
                  <li>Prikupljati podatke drugih korisnika bez pristanka</li>
                  <li>Kršiti prava intelektualnog vlasništva</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">5. Intelektualno vlasništvo</h2>
                <p className="text-stone-600 leading-relaxed">
                  Sav sadržaj, dizajn, logotipi i softver Bereket aplikacije zaštićeni su pravima intelektualnog vlasništva. 
                  Ne smijete kopirati, modificirati, distribuirati ili koristiti naš sadržaj bez izričitog pisanog odobrenja.
                </p>
                <p className="text-stone-600 leading-relaxed mt-4">
                  Kur'anski tekstovi i hadisi dostupni u aplikaciji koriste se iz javno dostupnih izvora i nisu naše 
                  intelektualno vlasništvo.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">6. Korisnički sadržaj</h2>
                <p className="text-stone-600 leading-relaxed">
                  Zadržavate vlasništvo nad sadržajem koji kreirate (dnevnički zapisi, osobne bilješke itd.). 
                  Dajete nam ograničenu licencu za pohranu i prikaz tog sadržaja u svrhu pružanja Usluge.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">7. Usluge trećih strana</h2>
                <p className="text-stone-600 leading-relaxed">
                  Naša Usluga koristi usluge trećih strana uključujući:
                </p>
                <ul className="list-disc list-inside text-stone-600 space-y-2 ml-4">
                  <li>Supabase za autentifikaciju i pohranu podataka</li>
                  <li>Google za prijavu putem Google računa</li>
                  <li>Aladhan API za vremena namaza</li>
                </ul>
                <p className="text-stone-600 leading-relaxed mt-4">
                  Korištenje ovih usluga podliježe njihovim vlastitim uvjetima korištenja.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">8. Odricanje od odgovornosti</h2>
                <p className="text-stone-600 leading-relaxed">
                  Usluga se pruža "kakva jest" bez ikakvih jamstava. Ne jamčimo da će Usluga biti neprekidna, 
                  sigurna ili bez grešaka. Vremena namaza pružena su samo informativno i trebaju se provjeriti 
                  s lokalnim izvorima.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">9. Ograničenje odgovornosti</h2>
                <p className="text-stone-600 leading-relaxed">
                  U maksimalnoj mjeri dopuštenoj zakonom, nećemo biti odgovorni za bilo kakve neizravne, slučajne, 
                  posebne ili posljedične štete koje proizlaze iz korištenja ili nemogućnosti korištenja Usluge.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">10. Prekid korištenja</h2>
                <p className="text-stone-600 leading-relaxed">
                  Možemo prekinuti ili suspendirati vaš pristup Usluzi bez prethodne najave ako prekršite ove 
                  Uvjete korištenja. Možete zatvoriti svoj račun u bilo kojem trenutku kontaktiranjem naše podrške.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">11. Izmjene uvjeta</h2>
                <p className="text-stone-600 leading-relaxed">
                  Zadržavamo pravo izmjene ovih Uvjeta korištenja u bilo kojem trenutku. O značajnim promjenama 
                  obavijestit ćemo vas putem aplikacije ili emaila. Nastavak korištenja Usluge nakon objave izmjena 
                  znači da prihvaćate nove uvjete.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">12. Mjerodavno pravo</h2>
                <p className="text-stone-600 leading-relaxed">
                  Ovi Uvjeti korištenja regulirani su i tumače se u skladu sa zakonima Republike Hrvatske, 
                  bez obzira na odredbe o sukobu zakona.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">13. Kontakt</h2>
                <p className="text-stone-600 leading-relaxed">
                  Za pitanja o ovim Uvjetima korištenja, kontaktirajte nas:
                </p>
                <div className="bg-stone-50 p-4 rounded-xl mt-4">
                  <p className="text-stone-700 font-medium">Email: app@islam-iznutra.com</p>
                </div>
              </section>
            </>
          ) : (
            <>
              {/* English Version */}
              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">1. Acceptance of Terms</h2>
                <p className="text-stone-600 leading-relaxed">
                  By using the Bereket web application ("Service"), you agree to these Terms of Service. 
                  If you disagree with any part of the terms, you may not use our Service.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">2. Description of Service</h2>
                <p className="text-stone-600 leading-relaxed">
                  Bereket is a spiritual activity tracking web application that allows users to:
                </p>
                <ul className="list-disc list-inside text-stone-600 space-y-2 ml-4">
                  <li>Track daily prayers</li>
                  <li>Record good deeds and barakah activities</li>
                  <li>Keep a spiritual journal</li>
                  <li>Use dhikr counters</li>
                  <li>Read the Quran</li>
                  <li>Track sadaqah (charity)</li>
                  <li>Plan spiritual activities</li>
                  <li>View prayer times and qibla direction</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">3. User Account</h2>
                <div className="space-y-3">
                  <h3 className="text-lg font-medium text-[#292524]">3.1 Registration</h3>
                  <p className="text-stone-600 leading-relaxed">
                    Registration is required to use certain features. You can register using an email address 
                    and password or via Google Sign-In.
                  </p>
                </div>
                <div className="space-y-3">
                  <h3 className="text-lg font-medium text-[#292524]">3.2 Account Responsibility</h3>
                  <p className="text-stone-600 leading-relaxed">
                    You are responsible for maintaining the confidentiality of your login credentials and for all 
                    activities that occur under your account.
                  </p>
                </div>
                <div className="space-y-3">
                  <h3 className="text-lg font-medium text-[#292524]">3.3 Accuracy of Information</h3>
                  <p className="text-stone-600 leading-relaxed">
                    You agree to provide accurate and complete information during registration and to update it 
                    when necessary.
                  </p>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">4. Acceptable Use</h2>
                <p className="text-stone-600 leading-relaxed">You agree not to:</p>
                <ul className="list-disc list-inside text-stone-600 space-y-2 ml-4">
                  <li>Use the Service for any unlawful purposes</li>
                  <li>Attempt unauthorized access to our systems</li>
                  <li>Interfere with or disrupt the Service</li>
                  <li>Transmit viruses or malicious code</li>
                  <li>Collect data from other users without consent</li>
                  <li>Infringe intellectual property rights</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">5. Intellectual Property</h2>
                <p className="text-stone-600 leading-relaxed">
                  All content, design, logos, and software of the Bereket application are protected by intellectual 
                  property rights. You may not copy, modify, distribute, or use our content without explicit written permission.
                </p>
                <p className="text-stone-600 leading-relaxed mt-4">
                  Quranic texts and hadiths available in the application are used from publicly available sources 
                  and are not our intellectual property.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">6. User Content</h2>
                <p className="text-stone-600 leading-relaxed">
                  You retain ownership of content you create (journal entries, personal notes, etc.). 
                  You grant us a limited license to store and display that content for the purpose of providing the Service.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">7. Third-Party Services</h2>
                <p className="text-stone-600 leading-relaxed">
                  Our Service uses third-party services including:
                </p>
                <ul className="list-disc list-inside text-stone-600 space-y-2 ml-4">
                  <li>Supabase for authentication and data storage</li>
                  <li>Google for Google Sign-In</li>
                  <li>Aladhan API for prayer times</li>
                </ul>
                <p className="text-stone-600 leading-relaxed mt-4">
                  Use of these services is subject to their own terms of service.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">8. Disclaimer</h2>
                <p className="text-stone-600 leading-relaxed">
                  The Service is provided "as is" without any warranties. We do not guarantee that the Service 
                  will be uninterrupted, secure, or error-free. Prayer times provided are for informational purposes 
                  only and should be verified with local sources.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">9. Limitation of Liability</h2>
                <p className="text-stone-600 leading-relaxed">
                  To the maximum extent permitted by law, we will not be liable for any indirect, incidental, 
                  special, or consequential damages arising from the use or inability to use the Service.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">10. Termination</h2>
                <p className="text-stone-600 leading-relaxed">
                  We may terminate or suspend your access to the Service without prior notice if you violate 
                  these Terms of Service. You may close your account at any time by contacting our support.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">11. Changes to Terms</h2>
                <p className="text-stone-600 leading-relaxed">
                  We reserve the right to modify these Terms of Service at any time. We will notify you of 
                  significant changes via the application or email. Continued use of the Service after posting 
                  of changes means you accept the new terms.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">12. Governing Law</h2>
                <p className="text-stone-600 leading-relaxed">
                  These Terms of Service are governed by and construed in accordance with the laws of the 
                  Republic of Croatia, without regard to conflict of law provisions.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-heading font-semibold text-[#292524]">13. Contact</h2>
                <p className="text-stone-600 leading-relaxed">
                  For questions about these Terms of Service, contact us:
                </p>
                <div className="bg-stone-50 p-4 rounded-xl mt-4">
                  <p className="text-stone-700 font-medium">Email: app@islam-iznutra.com</p>
                </div>
              </section>
            </>
          )}

          {/* Footer Links */}
          <div className="pt-8 border-t border-stone-200 flex flex-wrap gap-4">
            <Link to="/privacy" className="text-[#6B7B3F] hover:underline">
              {lang === 'hr' ? 'Politika privatnosti' : 'Privacy Policy'}
            </Link>
            <Link to="/" className="text-[#6B7B3F] hover:underline">
              {lang === 'hr' ? 'Povratak na početnu' : 'Back to Home'}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
